import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import {
  confirmAccountReducer,
  mapDispatchToProps,
  mapStateToProps,
} from "./AccountConfirmation.store";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import AccountConfirmation from "../../library/AccountConfirmation/AccountConfirmation";
import { modalType } from "../../../modules/constants";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SmartAccountConfirmation = (props) => {
  const {
    verifyToken,
    setOpenAuthModal,
    showAccountConfirmation,
    validate,
    error,
    isTokenValid,
    closeModalGoHome,
    accountValidated,
  } = props;

  const { t } = useTranslation();

  const token = props.match?.params.token;

  const openAccountConfirmation = useCallback(() => {
    setOpenAuthModal(
      modalType.accountConfirmation,
      t("appText.accountConfirmation.title")
    );
  }, [setOpenAuthModal, t]);

  const validateToken = useCallback(
    (token) => {
      if (!accountValidated && !error) {
        validate(token);
        verifyToken(token);
      }
    },
    [accountValidated, error, validate, verifyToken]
  );

  useEffect(() => {
    openAccountConfirmation();
    if (showAccountConfirmation) validateToken(token);
  }, [openAccountConfirmation, validateToken, token]);

  return showAccountConfirmation ? (
    <AccountConfirmation
      isTokenValid={isTokenValid}
      closeModalGoHome={closeModalGoHome}
      accountValidated={accountValidated}
      setOpenAuthModal={setOpenAuthModal}
    />
  ) : null;
};

export default dynamic(
  "confirmAccountReducer",
  subspaced({
    mapExtraState: (state) => ({ loginReducer: state.loginReducer }),
  }),
  attachReducer(confirmAccountReducer)
)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(SmartAccountConfirmation))
);
